import React, { useRef } from 'react';
import withLayout from '../hoc/withLayout';

const TestComponents = () => {
  const nameField = useRef();
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('hello');
    nameField.current.select.clearValue();
  };
  return (
    <div>
      <form
        action=''
        onSubmit={handleSubmit}
      >
        <input
          type='text'
          ref={nameField}
          placeholder='Enter anything'
        />
        <button>Submit</button>
      </form>
    </div>
  );
};

export default withLayout(TestComponents);
